MDB.FileShare = {};
MDB.FileShare.Share = {};
MDB.FileShare.Edit = {};
MDB.FileShare.Index = {};

MDB.FileShare.changeKendoDropZone = function () {
    var container = $('.k-widget.k-upload.k-header');
    container.removeClass('k-upload-empty');

    var dropzone = container.find('.k-dropzone');
    dropzone.children('em').text(MDB.loadResourceString("FileShare_Share_DropFiles_Text"));

    var button = dropzone.find(".k-upload-button");
    button.addClass('btn btn-primary');
    button.children('span').text(MDB.loadResourceString("FileShare_Share_SelectFiles_Button_Text"));
    $('#fileUploadDiv').show();
}

MDB.FileShare.boot = function (config) {

    $("#files").kendoUpload({
        async: {
            saveUrl: config.saveUrl,
            removeUrl: config.removeUrl,
            batch: true
        },
        success: function () {
            MDB.FileShare.reloadFiles();
        },
        upload: function (e) {
            e.data = {
                id: getId(),
                path: MDB.FileShare.getPath()
            };
        },
        error: onError
    });

    var rightsAjax = $('#rights-ajax-table');
    if (rightsAjax.length) {
        var dataTable = rightsAjax.dataTable()
            , columns = dataTable.fnSettings().aoColumns
            , tableApi = dataTable.api()
            , headers = rightsAjax.find('th')
            , sortOrder = [];

        _.forEach(headers, function (el, idx) {
            var $el = $(el);

            var order = $el.data('order');
            if (order) {
                sortOrder.push([idx, order]);
            }

            if (!$el.data('searchable')) {
                columns[idx].bSearchable = false;
                columns[idx].bSortable = false;
            }
        });
        tableApi.order(sortOrder).draw();
    }

    MDB.FileShare.deleteFiles = function () {
        MDB.prompt(
            MDB.loadResourceString('Fileshare_Files_Delete_Title'),
            sprintf(MDB.loadResourceString('Fileshare_Files_Delete_body'), name),
            function (ok) {
                if (ok) {
                    executeDelete();
                }
            }
        );
    };

    MDB.FileShare.createDirectory = function () {
        var newDir = $("#txtDir");

        var name = MDB.FileShare.getPath() + newDir.val();
        if (name !== "") {
            var id = getId();

            $.ajax({
                url: "/Fileshare/NewDirectory",
                type: "GET",
                data: {
                    Id: id,
                    name: name
                },
                cache: false,
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                success: function () {
                    MDB.FileShare.reloadFiles();
                }
            });
        }
        newDir.val("");
    };

    MDB.FileShare.downloadFiles = function (filename, preview) {
        var targetUrl = MDB.FileShare.generateDownloadLink(filename, { preview: preview !== undefined ? preview : false });
        
        if (preview && window.open) {
            window.open(targetUrl);
        } else {
            window.location.href = targetUrl;
        }
    };

    MDB.FileShare.shareFiles = function (filename) {
        var downloadLink = MDB.FileShare.generateDownloadLink(filename);

        var def = $.Deferred();
        var shareDownloadLinkPartialPromise = def.promise();

        $.ajax({
            url: '/FileShare/ShareDownloadLink',
            data: $.param({
                downloadLink: downloadLink,
                id: getId,
                isRoot: MDB.FileShare.isRoot()
            })
        }).done(function (result) {
            if (_.isObject(result) && result.Success === false) {
                def.reject(result);
                return;
            }

            def.resolve.apply($, arguments);
        }).fail(function () {
            def.reject.apply($, arguments);
        });

        var modal = MDB.modal({
            buttons: ['<button type="button" class="btn btn-default btn-share">Share</button>']
        });

        var body = modal.find('.modal-body');
        body.append($('<div />', {class: 'loading'}));

        shareDownloadLinkPartialPromise.done(function (partial) {
            partial = $(partial);
            partial.find('[name$="SelectedUsers"]').kendoMultiSelect({
                filter: 'contains'
            });

            if (document.execCommand) {
                partial.find('#btn-copy-to-clipboard').on('click', function () {
                    
                    var downloadLinkField = partial.find('[name$="DownloadLink"]');

                    downloadLinkField.val(MDB.FileShare.generateDownloadLink(filename, { useAbsoluteUrl: true}));
                    MDB.copyToClipboard(downloadLinkField);
                    downloadLinkField.val(downloadLink);
                });
            } 

            body.html(partial);

            modal.find('.btn-share').on('click', _.once(function () {
                var formData = modal.find('input,textarea,select');

                $.ajax({
                    url: '/FileShare/ShareDownloadLink',
                    type: 'POST',
                    data: formData.serialize()
                }).done(function (result) {
                    if (result.Value) {
                        if (result.Success === true) {
                            MDB.Notify.successGrowl(result.Value);
                        } else {
                            MDB.Notify.errorGrowl(result.Value);
                        }
                    }
                });

                MDB.killOpenModals();
            }));
        }).fail(function (result) {
            if (result.Value) {
                MDB.Notify.errorGrowl(result.Value);
            }
        });
    };

    MDB.FileShare.generateDownloadLink = function (filename, downloadOpts) {
        var names = {};
        var basePath = MDB.FileShare.getPath();
        
        if (filename !== undefined) {
            names = { name: basePath + filename };
        } else {
            _.forEach(MDB.FileShare.getSelectedFiles(), function (name, idx) {
                names[idx] = basePath + name;
            });
        }

        downloadOpts = $.extend(downloadOpts || {},
            {
                id: getId(),
                jsonNames: JSON.stringify(names),
                zipName: encodeURIComponent($('#Name').val())
            });

        var baseUrl = config.downloadBaseUrl;
        if (downloadOpts.useAbsoluteUrl === true) {
            delete downloadOpts.useAbsoluteUrl;
            baseUrl = config.downloadAbsoluteBaseUrl;
        }

        return baseUrl + '?' + $.param(downloadOpts);
    };

    MDB.FileShare.getSelectedFiles = function() {
        return _.map(_.filter(document.querySelectorAll('.delete-chk'), { checked: true }), 'id');
    };

    MDB.FileShare.selectFile = function (control) {
        $(control).parent().find('.delete-chk').click();
    };


    MDB.FileShare.checkAll = function () {
        var filesToCheck = document.querySelectorAll('.delete-chk');
        var unCheckedFiles = _.filter(filesToCheck, function (e) {
            return !e.checked; 
        });

        //Only check unchecked checkboxes
        if (unCheckedFiles.length !== 0) {
            $('.chk-all').prop( "checked", true );
            filesToCheck = unCheckedFiles;
        }

        for (var i = 0; i < filesToCheck.length; i++) {
            filesToCheck[i].click();
        }
    };

    MDB.FileShare.loadSubFolder = function (column) {
        var pathControl = $('#currentPath');
        var path = pathControl.val();
        var target = $(column).parent().find('.fileName').text();
        pathControl.val(path + target + "/");

        MDB.FileShare.reloadFiles();
        $(".k-upload-files.k-reset").remove();
    };

    MDB.FileShare.back = function () {
        var pathControl = $('#currentPath');
        var path = pathControl.val();

        pathControl.val(path.substring(0, path.lastIndexOf('/')));
        path = pathControl.val();

        pathControl.val(path.substring(0, path.lastIndexOf('/') + 1));

        MDB.FileShare.reloadFiles();
        $(".k-upload-files.k-reset").remove();
    };

    MDB.FileShare.deleteShare = function (input) {
        MDB.prompt(
            MDB.loadResourceString('Fileshare_Delete_Title'),
            sprintf(MDB.loadResourceString('Fileshare_Delete_body'), name),
            function (ok) {
                if (ok) {
                    $.ajax({
                        url: "/Fileshare/Delete",
                        type: "GET",
                        data: {
                            Id: input.id
                        },
                        cache: false,
                        contentType: "application/json; charset=utf-8",
                        dataType: "json",
                        success: function () {
                            window.location.href = config.deleteShareUrl;
                        }
                    });
                }
            }
        );
    }

    MDB.FileShare.updateUsers = function (element) {
        var id = element.value;
        var thisElement = "DivisionId";
        var controlId = element.id.substring(0, element.id.length - thisElement.length) + "UserId";

        $.ajax({
            url: config.updateUsersUrl,
            data: { id: id },
            datatype: "json",
            success: function (data) {
                $('#' + controlId + ' option').each(function () {
                    this.remove();
                });
                $.each(data.Value, function (i, item) {
                    $('#' + controlId).each(function () {
                        $(this).append($("<option></option>")
                            .text(item.Text)
                            .val(item.Value));
                    });
                });
            }
        });
    };

    if (MDB && MDB.KendoConfigBuilder && MDB.KendoConfigBuilder.extendablebleMultiDropdown) {
        MDB.KendoConfigBuilder.extendablebleMultiDropdown($('#Configuration_FileMask'));
    }

    MDB.FileShare.getPath = function() {
        return $('#currentPath').val();
    }

    MDB.FileShare.isRoot = function() {
        return MDB.FileShare.getPath() === '';
    }

    function getId() {
        return $('#FileShareId').val();
    }

    MDB.FileShare.reloadFiles = function (resetErrors) {
        if (resetErrors === undefined) {
            resetErrors = true;
        }

        var id = getId();
        var path = {};
        path.value = MDB.FileShare.getPath();

        var partial = config.reloadPartialUrl + "?Id=" + encodeURIComponent(id) + "&path=" + encodeURIComponent(JSON.stringify(path));

        showLoading();
        $("#displayFiles").load(partial, function () {
            hideLoading();
            MDB.FileShare.attachCheckFilesEvent();
        });

        if (MDB.FileShare.getPath() !== "") {
            $('#backButton').show();
        } else {
            $('#backButton').hide();
        }

        window.location.href = config.reloadBaseUrl + '#' + path.value;

        if (resetErrors) {
            $('#errorLabel').html("");
        }
    }

    MDB.FileShare.attachCheckFilesEvent = function () {
        $('.delete-chk').click('click', function () {
            var me = $(this);
            if (me.is(':checked')) {
                me.parent().parent().css("background-color", "lightblue");
            } else {
                me.parent().parent().css("background-color", "");
            }
        });
    }

    function executeDelete() {
        var filesToDelete = document.getElementsByClassName('delete-chk');

        var names = {};
        for (var i = 0; i < filesToDelete.length; i++) {
            if (filesToDelete[i].checked === true) {
                names[i] = (MDB.FileShare.getPath() + filesToDelete[i].id);
            }
        }

        var id = getId();
        var serializedNames = JSON.stringify(names);

        $.ajax({
            url: "/Fileshare/DeleteFiles",
            type: "GET",
            data: {
                Id: id,
                jsonNames: serializedNames
            },
            cache: false,
            contentType: "application/json; charset=utf-8",
            dataType: "json",
            success: function (data) {
                if (data.errors.length === 0) {
                    MDB.FileShare.reloadFiles();
                } else {
                    $('#errorLabel').html(data.errors);
                }
            }
        });
    }

    function hideLoading() {
        $('#loading').attr("hidden", true);
        $('#displayFiles').attr("hidden", false);
    }

    function showLoading() {
        $('#loading').attr("hidden", false);
        $('#displayFiles').attr("hidden", true);
    }

    function onError(e) {
        // An array with information about the uploaded files
        if (e.operation === "upload") {
            $('#errorLabel').html(e.XMLHttpRequest.responseText);
        }
        MDB.FileShare.reloadFiles(false);
    }
};

MDB.FileShare.Share.onload = function () {
    var hash = window.location.hash;
    var path = $('#currentPath');

    setInterval(function () {
        if (window.location.hash !== hash) {
            hash = window.location.hash;
            if (hash === '') {
                path.val('');
            }
            path.val(hash.replace('#', ''));
            MDB.FileShare.reloadFiles();
            $(".k-upload-files.k-reset").remove();
        }
    }, 100);

    $(function () {
        if (hash !== "") {
            path.val(hash.replace('#', ''));
            MDB.FileShare.reloadFiles();
        }

        $('#txtDir').keydown(function (e) {
            if (e.keyCode === 13) {
                MDB.FileShare.createDirectory();
            }
        });

        $('#addDir').click(function (e) {

        });

        MDB.FileShare.changeKendoDropZone();
        MDB.FileShare.attachCheckFilesEvent();
    });
};

$.extend(MDB.FileShare.Edit,
    {
        onload: function (config) {

            var dataTable = $('#user-rights-table');

            dataTable
                .dataTable({
                    "order": [[1, "asc"]],
                    "sDom": '<"H"lrf>t<"F"ip>',
                    drawCallback: function () {
                        $('.paginate_button', this.api().table().container())
                            .on('click', function () {
                                MDB.FileShare.Edit.addClickEventHandlers(config);
                            });
                    }

                });

            $('#fileshare-save-user').click(function (e) {
                e.preventDefault();
                var container = $('.new-user-container');
                var model = MDB.FileShare.Edit.serializeUserModel(container, 'add');

                model.IsNew = true;
                MDB.FileShare.Edit.modifyUser(config, model, 'add');
            });

            $('#submit').click(function (e) {
                e.preventDefault();
                var model = $('#fileshare-form').serialize();
                model.FolderPerDivision = $('#FolderPerDivision').val();
                MDB.FileShare.Edit.addFileShare(config.addFileshareUrl, model);
            });

            var id = $('#Id').val();
            if (id !== '00000000-0000-0000-0000-000000000000') {
                $('#user-rights-box').show();
            }
            MDB.FileShare.Edit.addClickEventHandlers(config);
        },
        updateClickEvent: function (button, config) {
            var me = $(button);

            me.click(function (e) {
                e.preventDefault();
                var container = me.parents('tr');
                var model = MDB.FileShare.Edit.serializeUserModel(container);

                model.IsNew = false;
                MDB.FileShare.Edit.modifyUser(config, model, 'update');
            });
        },
        deleteClickEvent: function (button, config) {
            var me = $(button);

            me.click(function (e) {
                e.preventDefault();
                var container = me.parents('tr');
                var model = MDB.FileShare.Edit.serializeUserModel(container, 'delete');
                MDB.FileShare.Edit.modifyUser(config, model, 'delete', container);
            });
        },
        //Unbind and rebind click event handlers.
        //Couldn't really think of a better way to do this, as rows are added in their alphabetical position.
        //Or even on different pages of the datatable, and rows need the click handlers as well
        //I didn't notice any effects on speed though.
        addClickEventHandlers: function (config) {  
            $('.fileshare-update-user').each(function (i, item) {
                $(item).unbind("click");
                MDB.FileShare.Edit.updateClickEvent(item, config);
            });

            $('.fileshare-delete-user').each(function (i, item) {
                $(item).unbind("click");
                MDB.FileShare.Edit.deleteClickEvent(item, config);
            });
        },
        modifyUser: function (config, model, action, userContainer) {
            var url = action !== 'add' ? config.updateUserUrl : config.addUserUrl;

            $.ajax({
                url: url + '?' + model,
                type: "GET",
                cache: false,
                dataType: "json",
                contentType: 'application/json; charset=utf-8',
                success: function (data) {
                    var errors;
                    if (data.errors !== undefined && data.errors.length !== 0) {
                        errors = data.errors.join(', ');
                        MDB.Notify.errorGrowl(errors, { timeout: 2000 });
                    } else {
                        if (action === 'add') {
                            MDB.FileShare.Edit.addRowToDataTable(data.model);
                            MDB.FileShare.Edit.addClickEventHandlers(config);
                            MDB.Notify.successGrowl(MDB.loadResourceString('FileShare_Edit_AddUser_Success_Message'), { timeout: 2000 });
                        } else if (action === 'delete') {
                            if (userContainer !== undefined) {
                                $('#user-rights-table').DataTable().row(userContainer).remove().draw();
                                MDB.Notify.successGrowl(MDB.loadResourceString('FileShare_Edit_RemoveRights_Success_Message'), { timeout: 2000 });
                            }
                        } else if (action === 'update') {
                            MDB.Notify.successGrowl(MDB.loadResourceString('FileShare_Edit_UpdateRights_Success_Message'), { timeout: 2000 });
                        }
                    }
                },
                error: function (e) {
                    console.warn(e);
                }
            });
        },
        addRowToDataTable: function (model) {
            var table = $('#user-rights-table').DataTable();

            table.row.add([
                '<input id="FileShareId" name="FileShareId" type="hidden" value="' + model.FileShareId + '">' +
                '<input id="IsNew" name="IsNew" type="hidden" value="' + model.IsNew + '">' +
                '<input id="DivisionId" name="DivisionId" type="hidden" value="' + model.DivisionId + '">' +
                '<label>' + model.DivisionName + '</label>',
                '<input id="UserId" name="UserId" type="hidden" value="' + model.UserId + '">' +
                '<label>' + model.UserName + '</label>',
                model.CanRead ?
                    '<input checked="checked" id="CanRead" name="CanRead" type="checkbox" value="true">' :
                    '<input id="CanRead" name="CanRead" type="checkbox" value="true">',
                model.CanWrite ?
                    '<input checked="checked" id="canWrite" name="canWrite" type="checkbox" value="true">' :
                    '<input id="canWrite" name="canWrite" type="checkbox" value="true">',
                model.CanViewSubFolders ?
                    '<input checked="checked" id="canViewSubFolders" name="canViewSubFolders" type="checkbox" value="true">' :
                    '<input id="canViewSubFolders" name="canViewSubFolders" type="checkbox" value="true">',
                model.CanCreateSubFolder ?
                    '<input checked="checked" id="canCreateSubFolders" name="canCreateSubFolders" type="checkbox" value="true">' :
                    '<input id="canCreateSubFolders" name="canCreateSubFolders" type="checkbox" value="true">',

                '<button class="fileshare-update-user btn btn-sm btn-secondary">' +
                '<i class= "fa fa-save" ></i> ' + MDB.loadResourceString('Button_Save') +
                '</button > ' +
                '<button class="fileshare-delete-user btn btn-sm btn-secondary">' +
                '<i class="fa fa-minus-circle"></i> ' + MDB.loadResourceString('FileShareSourcePerUser_Rights_DeleteBtn_DisplayText') +
                '</button>'
            ]);
            table.draw();
        },

        addFileShare: function (url, model) {
            url = (url.substring(0, url.lastIndexOf('/')));

            $.ajax({
                url: url + '?' + model,
                type: 'POST',
                cache: false,
                datatype: 'json',
                contentType: 'application/json; charset=utf-8',
                success: function (data) {
                    if (data.errors !== undefined) {
                        MDB.Notify.errorGrowl(data.errors.join(', '), { timeout: 2000 });
                    } else {
                        $('#Id').val(data.id);
                        var oldUrl = window.location.href;
                        var actual = (oldUrl.substring(0, oldUrl.lastIndexOf('/')) + '/' + $('#Id').val());
                        history.pushState({ id: 'Edit' }, 'Edit FileShare', actual);
                        $('#user-rights-box').show();
                        MDB.Notify.successGrowl(MDB.loadResourceString('FileShare_Edit_SaveShare_Success_Message'), { timeout: 2000 });
                    }
                }
            });
        },
        serializeUserModel: function (container, action) {

            var isNew = action === 'add' ? true : false;
            var isDeleted = action === 'delete' ? true : false;
            var fileShareId = $('#Id').val();

            //Serialize manually, because the way checkboxes were handled was pissing me off.
            return 'FileShareId=' +
                encodeURIComponent(fileShareId) +
                '&UserId=' +
                encodeURIComponent(container.find('#UserId').val()) +
                '&UserName=' +
                encodeURIComponent(container.find('#UserId').children("option").filter(":selected").text()) +
                '&DivisionId=' +
                encodeURIComponent(container.find('#DivisionId').val()) +
                '&CanRead=' +
                encodeURIComponent(container.children()[2].children[0].checked) +
                '&CanWrite=' +
                encodeURIComponent(container.children()[3].children[0].checked) +
                '&CanViewSubFolders=' +
                encodeURIComponent(container.children()[4].children[0].checked) +
                '&CanCreateSubFolder=' +
                encodeURIComponent(container.children()[5].children[0].checked) +
                '&IsDeleted=' + isDeleted +
                '&IsNew=' + isNew;
        }
    });

MDB.FileShare.Index.onload = function () {
    $('#sharesTable').dataTable({
        "order": [[2, "asc"]],
        "sDom": '<"H"lrf>t<"F"ip>'
    });
};